module.exports = __webpack_public_path__ + "img/Rectangle.9bb1e16f.png";